const TOKEN_KEY = 'token'
//const REFRESH_TOKEN_KEY = 'refresh_token'
const ROLE_KEY = 'roles'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
    getToken() {
        return window.localStorage.getItem(TOKEN_KEY);
    },

    saveToken(accessToken) {
        window.localStorage.setItem(TOKEN_KEY, accessToken);
    },

    saveRoles(roles) {
        window.localStorage.setItem(ROLE_KEY, roles);
    },

    saveUserName(userName) {
        window.localStorage.setItem('userName', userName);
    },

    getRoles() {
        return (window.localStorage.getItem(ROLE_KEY) || []);
    },

    removeToken() {
        window.localStorage.removeItem(TOKEN_KEY);
        window.localStorage.removeItem(ROLE_KEY);
    },

    getUserName() {
        return (window.localStorage.getItem('userName') || '');
    },

    // getRefreshToken() {
    //     return localStorage.getItem(REFRESH_TOKEN_KEY);
    // },

    // saveRefreshToken(refreshToken) {
    //     localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    // },

    // removeRefreshToken() {
    //     localStorage.removeItem(REFRESH_TOKEN_KEY);
    // }

}

export { TokenService }